import isotipoAzul from '../../assets/marca/isotipo-pasos-azul.svg';
import isotipoBlanco from '../../assets/marca/isotipo-pasos-blanco.svg';
import logoAzul from '../../assets/marca/logo-pasos-azul.svg';
import logoBlanco from '../../assets/marca/logo-pasos-blanco.svg';
import { SISTEMA } from '../../copy/index.js';

/**
 * El logo del programa · la marca real, no un texto que la imite.
 *
 * Usa el vector oficial "Pasos+" (LOGO-1, 04/10/2026), que reemplazó al PNG
 * "Pasos Programa" recortado de la imagen de Fundación. Los SVG de
 * `assets/marca/` son los de Illustrator normalizados sin tocar los trazos: el
 * color como `fill`, sin estilos ni ids (`marca.test.ts` lo verifica).
 *
 * - `forma`: el logo completo (isotipo + "Pasos+") o sólo el isotipo, las dos
 *   cápsulas, para donde no entra el nombre.
 * - `fondo`: sobre qué superficie va. Sobre navy se usa la versión blanca; sobre
 *   una superficie clara, la azul de la marca. No es una preferencia estética:
 *   la versión equivocada queda sin contraste.
 *
 * El alto lo decide quien lo usa (`className`), el ancho sigue la proporción.
 * `decorativo` deja el `alt` vacío para cuando el nombre ya está escrito al lado:
 * un lector de pantalla no tiene por qué leer la marca dos veces.
 */

const ARCHIVO = Object.freeze({
  completo: { oscuro: logoBlanco, claro: logoAzul },
  isotipo: { oscuro: isotipoBlanco, claro: isotipoAzul },
});

/**
 * Proporciones de los `viewBox` (333,75 x 95,77 y 63,85 x 95,77) en enteros,
 * para que el navegador reserve el lugar antes de cargar la imagen.
 */
const MEDIDA = Object.freeze({
  completo: { ancho: 3338, alto: 958 },
  isotipo: { ancho: 639, alto: 958 },
});

export function Logo({
  forma = 'completo',
  fondo,
  decorativo = false,
  className = 'h-10 w-auto',
}: {
  forma?: 'completo' | 'isotipo';
  fondo: 'oscuro' | 'claro';
  decorativo?: boolean;
  className?: string;
}) {
  return (
    <img
      alt={decorativo ? '' : SISTEMA.marca.logo}
      className={`block ${className}`}
      height={MEDIDA[forma].alto}
      src={ARCHIVO[forma][fondo]}
      width={MEDIDA[forma].ancho}
    />
  );
}
